<template>
	<div class="st-area">
	  <van-popup v-model:show="showPicker" round position="bottom" :close-on-click-overlay="false">
			<van-area 
				title="标题" 
				:area-list="areaList" 
				:value="defVal" 
				@cancel="pickerCancel"
				@confirm="pickerConfirm"
			/>
		</van-popup>
	  <div :data-readonly="readonly ? 1 : 0" style="position: relative;">
	    <van-field
	      class="st-form-item-input"
	      ref="select-input"
	      is-link
	      v-model="text"
	      :name="name"
	      label=""
	      :placeholder="placeholder"
	      @click="onClick"
	      readonly
				clearable
	    />
			<div @click="clearVal" v-if="val && clearable" style="display: inline-block;position: absolute;top: 10px;right: 40px;font-size: 20px;color: #f1b9b9;"><van-icon name="close" /></div>
			
	  </div>
	</div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    name: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    label: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return '';
      }
    },
    readonly: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		clearable: {
		  type: Boolean,
		  default: () => {
		    return false;
		  }
		},
		
  },
  data() {
    return {
      showPicker: false,
      val: this.value,
      text: this.defText,
			areaList: {
				province_list: {},
				city_list: {},
				county_list: {},
			},
      pickerVal: 0,
			defVal: '',
    };
  },
  created() {
    this.init();
    setTimeout(() => {
      this.$watch('value', (newV, oldV) => {
        if (newV !== oldV) {
          this.val = newV;
          this.setText();
        }
      });

      this.$watch('text', (newV, oldV) => {
        if (newV !== oldV) {
          this.$emit('changeText', this.text);
        }
      });
    }, 0)
  },
  mounted() {
  },
  watch: {},
  methods: {
    init() {
      this.getAreas();
			this.setText();
    },
		async getAreas() {
			await this.$post(this.$api.getAreas, {}).then((res) => {
				for (let i in res.data) {
					this.$set(this.areaList, [i + '_list'], res.data[i]);
				}
				
				for (let i in this.areaList['province_list']) {
					this.areaList['city_list'][i] = '';
				}
				
				for (let i in this.areaList['city_list']) {
					this.areaList['county_list'][i] = '';
				}
			});
			
		},
    // 设置要显示的文本
    setText() {
			if (!this.val) {
				this.text == this.val;
			} else {
				let val_arr = this.val.split('/');
				let len = val_arr.length;
				let ed = val_arr.pop();
				
				if (len == 1) {
					this.defVal = Object.keys(this.areaList['province_list']).find(key => this.areaList['province_list'][key] === ed);
				} else if(len == 2) {
					this.defVal = Object.keys(this.areaList['city_list']).find(key => this.areaList['city_list'][key] === ed);
				} else if(len == 3) {
					this.defVal = Object.keys(this.areaList['county_list']).find(key => this.areaList['county_list'][key] === ed);
				}
				
				this.text = this.val;
			}
			
    },
    // 点击输入框
    onClick() {
      this.showPicker = true;
      this.$emit('click');
    },
		
		clearVal() {
			this.val = '';
			this.text = '';
			this.$emit('input', this.val);
		},
    // 选择确定提交
    pickerConfirm(obj, ind) {
			let name_arr = obj.map(v => { return v.name; });
			name_arr = name_arr.filter(v => { return v !== ''; });
			this.val = name_arr.join('/');
      this.$emit('change', this.val, this.text)
      this.$emit('input', this.val);

      // 触发input blur 事件
      this.emitInputBlur();
      this.showPicker = false;
    },

    // 触发input blur 事件
    emitInputBlur() {
      this.$nextTick(() => {
        let ele = this.$refs['select-input'].$el.querySelector('input');
        ele.focus();
        ele.blur();
      })
    },

    // 取消选择
    pickerCancel() {
      this.showPicker = false;
      // 触发input blur 事件
      this.emitInputBlur();
    },

  },
};
</script>

<style lang="scss" scoped>
.st-area {
  .van-field {
    box-shadow: inset 0 0 0 2px rgb(223,223,223);
    border-radius: 5px;
  }

  div[data-readonly='1'] .van-field{
    background-color: rgba(233, 233, 233, 1);
  }
}
</style>
